import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { WCSupplier } from '../../types/wordpress';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

interface SupplierFormProps {
    initialValues?: WCSupplier | null;
    onSubmit: (values: Partial<WCSupplier>) => void;
    onCancel: () => void;
}

const SupplierForm: React.FC<SupplierFormProps> = ({ initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={initialValues || {}}
            onFinish={onSubmit}
        >
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="company_name"
                        label="Company Name"
                        rules={[{ required: true, message: 'Please enter company name' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="contact_name"
                        label="Contact Name"
                        rules={[{ required: true, message: 'Please enter contact name' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: 'Please enter email' },
                            { type: 'email', message: 'Please enter a valid email' }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="phone"
                        label="Phone"
                        rules={[{ required: true, message: 'Please enter phone number' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                        name="address"
                        label="Address"
                        rules={[{ required: true, message: 'Please enter address' }]}
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="tax_id"
                        label="Tax ID"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="payment_terms"
                        label="Payment Terms"
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Form.List name="contacts">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(({ key, name, ...restField }) => (
                            <Row gutter={16} key={key}>
                                <Col span={5}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'contact_name']}
                                        label="Contact Name"
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'phone_number']}
                                        label="Phone"
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={5}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'email']}
                                        label="Email"
                                        rules={[{ type: 'email', message: 'Invalid email' }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'web_site']}
                                        label="Website"
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>

                                <Col span={1} style={{ marginTop: 32 }}>
                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                </Col>
                            </Row>
                        ))}
                        <Form.Item>
                            <Button
                                type="dashed"
                                onClick={() => {
                                    const contacts = form.getFieldValue('contacts') || [];
                                    add(); // Make first contact default
                                }}
                                block
                                icon={<PlusOutlined />}
                            >
                                Add Contact
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
            <Form.Item>
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={onCancel} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit">
                        {initialValues ? 'Update' : 'Create'} Supplier
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
};

export default SupplierForm; 